<mprd-joint-offer-skeleton *ngIf="fetching"></mprd-joint-offer-skeleton>
<section class="rs-content-wrapper rs-header-has-level2" *ngIf="!fetching">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2 rs-has-subtit">
            {{ 'mobile.jointOffer.title' | translate }}
          </h1>
          <p class="rs-txt-s5 rs-txt-c2 small-only-text-center" x-ms-format-detection="none">
            <mprd-access-number-formatter
              [accessNumber]="mobileProductDetails.accessNumber"
              [plc]="mobileProductDetails.plc"
            ></mprd-access-number-formatter>
          </p>

          <div class="rs-panel-big rs-bg-c2 clearfix" *ngIf="jointOffer">
            <h2 class="rs-tit3">
              {{ 'mobile.jointOffer.equipment.title' | translate }}
            </h2>

            <div class="row">
              <div class="columns small-12 medium-6">
                <div class="panel rs-bg-grey1">
                  <div class="text-center">
                    <img
                      alt=""
                      [src]="jointOffer?.icon"
                      data-src="{{ jointOffer?.icon }}"
                      data-cy="jointOfferImage"
                    />
                  </div>
                </div>
              </div>
              <div class="columns small-12 medium-6">
                <div class="panel rs-bg-grey1 rs-no-margin rs-no-radius-bottom clearfix">
                  <h3 class="rs-tit6 rs-txt-c1" data-cy="jointOfferDeviceName">
                    {{ jointOffer?.name }}
                  </h3>
                  <p data-cy="jointOfferEndDate">
                    {{ 'mobile.jointOffer.endDate' | translate }}
                    <strong>{{ jointOffer.deactivationDate }}</strong>
                  </p>
                  <p *ngIf="isPayer">
                    {{ 'mobile.jointOffer.stillToPay' | translate }}
                    <strong
                      ><px-currency-amount
                        [amount]="jointOffer?.residualAmount?.amount.toString()"
                        data-cy="jointOfferAmount"
                      ></px-currency-amount
                    ></strong>
                  </p>
                </div>
                <div class="panel rs-bg-grey2 rs-no-radius-top clearfix">
                  <p>
                    {{ 'mobile.jointOffer.knowMore.label' | translate }}<br /><a
                      href="{{ 'mobile.jointOffer.knowMore.link.url' | translate }}"
                      >{{ 'mobile.jointOffer.knowMore.link.label' | translate }}</a
                    >
                  </p>
                </div>
                <ng-container *ngIf="isProductOfferEligibleForPenalty">
                  <mprd-jo-renewal-card [product]="mobileProductDetails"></mprd-jo-renewal-card>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
